import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SingleVault from './SingleVault';
import BottomDrawer, { DrawerButtonsWrapper } from '../Drawer/Drawer';
import { ReactComponent as ArrowRight } from '../../assets/images/svg/arrow-right.svg';
import Button from '../Button/Button';
import SectionLoader from '../Loader/SectionLoader';

const ContentWrapper = styled.div`
  > div {
    min-height: 130px;
  }
`;

const SelectVaultLocation = ({
  open,
  setOpen,
  wizardData,
  setWizardData,
  lowestVault,
  setOpenSelectStorageType,
  // accountUid,
  sortedLocations,
  isLoading,
  locations,
}) => {
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const [locations, setLocations] = useState({
  //   otherLocations: [],
  // });
  // const locationPrices = useSelector(selectLocationPrices);
  // const { storageProduct } = wizardData;

  // useEffect(() => {
  //   // if (isEmpty(storageProduct)) {
  //   //   return;
  //   // }

  //   // const { Locations } = storageProduct;

  //   if (sortedLocations) {
  //     // const otherLocations = Locations.filter(
  //     //   (location) => location.LocationType !== 12,
  //     // );

  //     setLocations(sortedLocations);
  //   }
  // }, [sortedLocations]);

  const isVaultSelected = (vault) => {
    if (!wizardData?.selectedVault) return false;
    return wizardData.selectedVault?.LocationType === vault.LocationType;
  };

  const selectVault = (vault) => {
    const matchedLocation = locations.find(
      (loc) => loc.LocationType === vault.LocationType,
    );

    setWizardData({
      ...wizardData,
      selectedVault: {
        ...matchedLocation,
        ...vault,
      },
    });

    // setWizardData({ ...wizardData, selectedVault });
  };

  const goToSelectStorageType = () => {
    // setOpen(false);
    setOpenSelectStorageType(true);
  };

  return (
    <BottomDrawer
      isOpen={open}
      onClose={() => setOpen(false)}
      title={t('buyWizard.selectVaultLocationTitle')}
      subtitle={t('buyWizard.selectVaultLocationSubtitle')}
      footer={
        <DrawerButtonsWrapper>
          <Button
            variant="primaryOutlined"
            textTransform="none"
            onClick={() => setOpen(false)}
          >
            {t('buyWizard.continueWithStandardStorage')}
          </Button>
          <Button
            variant="primary"
            textTransform="none"
            onClick={goToSelectStorageType}
            disabled={!wizardData?.selectedVault?.IsAvailableForSegregated}
          >
            {t('buyWizard.compareStorageOptions')}
            <ArrowRight />
          </Button>
        </DrawerButtonsWrapper>
      }
    >
      <ContentWrapper>
        <SectionLoader isLoading={isLoading}>
          {sortedLocations.map((location) => (
            <SingleVault
              key={location?.LocationType}
              isTestProduct={location.IsTestProduct}
              isVaultSelected={isVaultSelected(location)}
              selectVault={() => selectVault(location)}
              vault={location}
              isLowestPriceVault={lowestVault}
            />
          ))}
        </SectionLoader>
      </ContentWrapper>
    </BottomDrawer>
  );
};

SelectVaultLocation.propTypes = {
  wizardData: PropTypes.shape({
    storageProduct: PropTypes.shape({
      Locations: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    selectedVault: PropTypes.shape({
      LocationType: PropTypes.number,
      IsAvailableForSegregated: PropTypes.bool,
    }),
  }),
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setWizardData: PropTypes.func,
  lowestVault: PropTypes.shape({}),
  setOpenSelectStorageType: PropTypes.func,
  sortedLocations: PropTypes.arrayOf(PropTypes.shape({})),
  isLoading: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SelectVaultLocation;
